/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  PMD Phases step 4 of the input view
Author: Deimos Space UK

Version: 1.0
*/
import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import GeneralInputs from './GeneralInputs/GeneralInputs'
import KeplerianInputs from './KeplerianInputs/KeplerianInputs'
import DirectDisposal from './DirectDisposal/DirectDisposal'
import TargetedDeorbit from './TargetedDeorbit/TargetedDeorbit'
import Reorbit from './Reorbit/Reorbit'
import Switch from "react-switch";
import { Row, Col, Form, Button,OverlayTrigger, Tooltip,  } from 'react-bootstrap';
import { postPetition } from '../../../../api/api'
import JSZip from 'jszip'
import db from '../../../../utils/db/db'
import FileUpload from '../../../../core/components/FileUpload/FileUpload';
import style from './PMDPhase.module.css'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

function PMDphases(props) {
  const navigate = useNavigate()
  const [step4, setStep4] = useState({})
  const [filesArray, setFilesArray] = useState([])
  const [directDisposal, setDirectDisposal] = useState(false)
  const [targetedDeorbitState, setTargetedDeorbit] = useState(false)
  const [reorbitState, setReorbitState] = useState(false)
  const [noDisposal, setNoDisposal] = useState(true)
  const [change, setChange] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [architectureType, setArchitectureType] = useState('')
  const [reorbitFile, setReorbitFile] = useState(null)
  const [targetedDeorbitFile, setTargetedDeorbitFile] = useState(null)
  const [directDisposalFile, setDirectDisposalFile] = useState(null)
  const [noDisposalFile, setNoDisposalFile] = useState(null)
  const [kingHele, setKingHele] = useState(false)
  const location = useLocation()
  const [propulsionType, setPropulsionType] = useState('')

  useEffect(() => {
    const data = sessionStorage.getItem('fourthStep');
    const step1 = sessionStorage.getItem('firstStep');
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'));
    const step3 = JSON.parse(sessionStorage.getItem('thirdStep'));
    if (data) {
      const formData = JSON.parse(data);
      setStep4(formData)
      setDirectDisposal(formData.directDisposal)
      setTargetedDeorbit(formData.targetedDeorbit)
      setReorbitState(formData.reorbit)
      setNoDisposal(formData.noDisposal)
      const files = []
      if (formData.directDisposal && formData.directDisposalData.type === 'file') {
        setDirectDisposalFile(true)
        files.push({
          name: 'directDisposal',
          type: 'file',
          file_name: formData.directDisposalData.file_name,
        })
      }
      if (formData.targetedDeorbit && formData.targetedDeorbitData.type === 'file') {
        setTargetedDeorbitFile(true)
        files.push({
          name: 'targetedDeorbit',
          type: 'file',
          file_name: formData.targetedDeorbitData.file_name,
        })
      }
      if (formData.reorbit && formData.reorbitData.type === 'file') {
        setReorbitFile(true)
        files.push({
          name: 'reorbit',
          type: 'file',
          file_name: formData.reorbitData.file_name,
        })
      }
      if (formData.noDisposal && formData.noDisposalData && formData.noDisposalData.type === 'file') {
        setNoDisposalFile(true)
        files.push({
          name: 'noDisposal',
          type: 'file',
          file_name: formData.noDisposalData.file_name,
        })
      }
      setFilesArray(files)

    } else {
      setStep4({
        startEpoch: '',
        crossSection: '',
        dragCoefficient: '',
        reflectivityCoefficient: '',
        semiMajorAxis: '',
        eccentricity: '',
        inclination: '',
        rightAscension: '',
        argumentOfPerigee: '',
        meanAnomaly: '',
        directDisposal: false,
        targetedDeorbit: false,
        reorbit: false,
        noDisposal: true,
        directDisposalData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          targetPerigee: '',
        },
        targetedDeorbitData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          hohmannTransfer: '',
          lifetimeLimit: '',
          crossSection: '',
          dragCoefficient: '',
          reflectivityCoefficient: '',
        },
        reorbitData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          hohmannTransfer: '',
          reorbitAltitude: '',
        },


      }
      )
    }
    if (step2 && step2[0].PropulsionTechnology) {
      setPropulsionType(step2[0].PropulsionTechnology.propulsionTechnology.value)
    }
    if (!data && step3 && step3[0].operationalPhase && step3[0].operationalPhase[0] && architectureType !== 'constellation') {
      if (step3[0].operationalPhase[0].keplerian) {
        setStep4({
          ...step4,
          startEpoch: step3[0].operationalPhase[0].end_epoch,
          dragCoefficient: '2.2',
          reflectivityCoefficient: '1.3',
          crossSection: step2[0]?.SpacecraftDesign?.cross,
          semiMajorAxis: step3[0].operationalPhase[0].keplerian.sma,
          meanAnomaly: step3[0].operationalPhase[0].keplerian.mean_anomaly,
          eccentricity: step3[0].operationalPhase[0].keplerian.eccentricity,
          inclination: step3[0].operationalPhase[0].keplerian.inclination,
          rightAscension: step3[0].operationalPhase[0].keplerian.raan,
          argumentOfPerigee: step3[0].operationalPhase[0].keplerian.argument_perigee,
        })
      }
    }

    setArchitectureType(JSON.parse(step1).architectureType)
  }, [])

  useEffect(() => {
    if (props.id) {
      if (location.pathname.includes('clone')) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
  }, [props.id, location.pathname])

  useEffect(() => {
    if (!directDisposal && !targetedDeorbitState && !reorbitState) {
      setNoDisposal(true)
    }
  }, [directDisposal, targetedDeorbitState, reorbitState])

  const getFilesAndZip = async () => {
    const fileArray = await db.files.toArray();
    const zip = new JSZip();
    if (!fileArray || !fileArray.length) return;
    fileArray.forEach((file) => {
      zip.file(file.name, file.data);
    });
    const content = await zip.generateAsync({ type: 'blob' });
    return content;
  }

  const changeDirectDisposal = () => {
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'));
    setStep4({
      ...step4,
      directDisposal: !directDisposal
    })
    if (!directDisposal === true) {
      if (directDisposalFile) {
        setDirectDisposalFile(false)
        onFileDelete('directDisposal')
        db.files
          .where('phaseName')
          .equals('directDisposal')
          .and((file) => file.pmd === true)
          .delete()

      }
      setStep4({
        ...step4,
        directDisposal: false,
        directDisposalData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          targetPerigee: '',
        }
      })
    }

    setDirectDisposal(!directDisposal)
    setChange(!change)
  }
  const changeTargetedDeorbit = () => {
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'));
    setStep4({
      ...step4,
      targetedDeorbit: !targetedDeorbitState
    })

    if (!targetedDeorbitState === true) {
      if (targetedDeorbitFile) {
        setTargetedDeorbitFile(false)
        onFileDelete('targetedDeorbit')
        db.files
          .where('phaseName')
          .equals('targetedDeorbit')
          .and((file) => file.pmd === true)
          .delete()

      }
      setStep4({
        ...step4,
        targetedDeorbit: false,
        targetedDeorbitData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          hohmannTransfer: '',
          lifetimeLimit: '',
          crossSection: '',
          dragCoefficient: '',
          reflectivityCoefficient: '',
        }
      })
    }
    setTargetedDeorbit(!targetedDeorbitState)

    setChange(!change)

  }
  const changeReorbit = () => {
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'));
    setStep4({
      ...step4,
      reorbit: !reorbitState
    })
    if (!reorbitState === true) {
      if (reorbitFile) {
        setReorbitFile(false)
        onFileDelete('reorbit')
        db.files

          .where('phaseName')
          .equals('reorbit')
          .and((file) => file.pmd === true)
          .delete()

      }
      console.log(step2[0]?.PropulsionTechnology?.propulsionTechnology)
      setStep4({
        ...step4,
        reorbit: !reorbitState,
        reorbitData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          hohmannTransfer: '',
          reorbitAltitude: '',
        }
      })
    }
    setReorbitState(!reorbitState)
    setChange(!change)
  }
  const changeNoDisposal = () => {
    setStep4({
      ...step4,
      noDisposal: !noDisposal
    })
    setNoDisposal(!noDisposal)
    setChange(!change)

  }

  const changeStarEpoch = (value) => {

    setStep4({
      ...step4,
      startEpoch: value
    })

  }
  const changeCrossSection = (value) => {

    setStep4({
      ...step4,
      crossSection: value
    })
  }
  const changeDragCoefficient = (value) => {

    setStep4({
      ...step4,
      dragCoefficient: value
    })
  }
  const changeReflectivityCoefficient = (value) => {

    setStep4({
      ...step4,
      reflectivityCoefficient: value
    })
  }

  const changeSemiMajorAxis = (value) => {

    setStep4({
      ...step4,
      semiMajorAxis: value
    })
  }

  const changemMeanAnomaly = (value) => {

    setStep4({
      ...step4,
      meanAnomaly: value
    })
  }

  const changeEccentricity = (value) => {

    setStep4({
      ...step4,
      eccentricity: value
    })
  }

  const changeInclination = (value) => {

    setStep4({
      ...step4,
      inclination: value
    })
  }

  const changeRightAscension = (value) => {

    setStep4({
      ...step4,
      rightAscension: value
    })
  }

  const changeArgumentOfPerigee = (value) => {

    setStep4({
      ...step4,
      argumentOfPerigee: value
    })
  }

  const changeTargetPerigee = (value) => {
    setStep4({
      ...step4,
      directDisposalData: {
        ...step4.directDisposalData,
        targetPerigee: value
      }
    })
  }

  const onChangeDisposalSystemTargetedDeorbit = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        disposalSystem: value
      }
    })
  }

  const changeHohmannTransferTargetedDeorbit = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        hohmannTransfer: value
      }
    })
  }

  const changeLifetimeLimit = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        lifetimeLimit: value
      }
    })
  }

  const changeTargetedDeorbitCrossSection = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        crossSection: value
      }
    })
  }

  const changeTargetedDeorbitDragCoefficient = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        dragCoefficient: value
      }
    })
  }

  const changeTargetedDeorbitReflectivityCoefficient = (value) => {
    setStep4({
      ...step4,
      targetedDeorbitData: {
        ...step4.targetedDeorbitData,
        reflectivityCoefficient: value
      }
    })
  }

  const changeHohmanTransferReorbit = (value) => {
    setStep4({
      ...step4,
      reorbitData: {
        ...step4.reorbitData,
        hohmannTransfer: value
      }
    })
  }

  const onChangeDisposalSystemReorbit = (value) => {
    setStep4({
      ...step4,
      reorbitData: {
        ...step4.reorbitData,
        disposalSystem: value
      }
    })
  }

  const changeReorbitAltitude = (value) => {
    setStep4({
      ...step4,
      reorbitData: {
        ...step4.reorbitData,
        reorbitAltitude: value
      }
    })
  }

  const validate = () => {
    let isValid = true;
    if (architectureType === 'constellation') {
      return false
    }
    if (step4.startEpoch === '') {
      isValid = false;
    }
    if (step4.semiMajorAxis === '') {
      isValid = false;
    }
    if (step4.meanAnomaly === '') {
      isValid = false;
    }
    if (step4.eccentricity === '') {
      isValid = false;
    }
    if (step4.inclination === '') {
      isValid = false;
    }
    if (step4.rightAscension === '') {
      isValid = false;
    }
    if (step4.argumentOfPerigee === '') {
      isValid = false;
    }
    if (step4.crossSection === '') {
      isValid = false;
    }
    if (step4.dragCoefficient === '') {
      isValid = false;
    }
    if (step4.reflectivityCoefficient === '') {
      isValid = false;
    }
    if (step4.directDisposal) {
      if (step4.directDisposalData?.targetPerigee === '') {
        isValid = false;
      }
    }
    if (step4.targetedDeorbit) {
      if (step4.targetedDeorbitData?.disposalSystem === '') {
        isValid = false;
      }
      if (step4.targetedDeorbitData?.lifetimeLimit === '') {
        isValid = false;
      }
      if (step4.targetedDeorbitData?.disposalSystem?.value === 'dragAugmentationDevice') {
        if (step4.targetedDeorbitData?.crossSection === '') {
          isValid = false;
        }
        if (step4.targetedDeorbitData?.dragCoefficient === '') {
          isValid = false;
        }
        if (step4.targetedDeorbitData?.reflectivityCoefficient === '') {
          isValid = false;
        }

      }

      if (step4.targetedDeorbitData?.disposalSystem?.value === 'chemical') {
        if (step4.targetedDeorbitData?.hohmannTransfer === '') {
          isValid = false;
        }
      }
    }
    if (step4.reorbit) {
      if (step4.reorbitData?.disposalSystem === '') {
        isValid = false;
      }
      if (step4.reorbitData?.disposalSystem?.value === 'chemical') {
        if (step4?.reorbitData?.hohmannTransfer === '') {
          isValid = false;
        }

      }
      if (step4?.reorbitData?.reorbitAltitude === '') {
        isValid = false;
      }
    }

    return !isValid;
  }

  const resetManualAndKemeplerian = () => {
    setStep4({
      ...step4,
      startEpoch: '',
      semiMajorAxis: '',
      meanAnomaly: '',
      eccentricity: '',
      inclination: '',
      rightAscension: '',
      argumentOfPerigee: '',
      crossSection: '',
      dragCoefficient: '',
      reflectivityCoefficient: '',
    })
  }

  const saveStep4 = () => {
    sessionStorage.setItem('fourthStep', JSON.stringify(step4))
  }
  const pmdConstallationSchema = (index) => {
    let pmdSchema = []
    const fourthStep = JSON.parse(sessionStorage.getItem('fourthStepConstellation'))
    if (directDisposal) {
      if (directDisposalFile) {
        const name = filesArray.find(file => file.name === 'directDisposal').file_name
        const directDisposalFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(directDisposalFileSchema)
      } else {
        const directDisposalSchema = {
          keplerian: {
            raan: parseFloat(fourthStep[index].rightAscension),
            argument_perigee: parseFloat(fourthStep[index].argumentOfPerigee),
            sma: parseFloat(fourthStep[index].semiMajorAxis),
            eccentricity: parseFloat(fourthStep[index].eccentricity),
            inclination: parseFloat(fourthStep[index].inclination),
            mean_anomaly: parseFloat(fourthStep[index].meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(fourthStep[index].startEpoch),
            reflectivity_coefficient: parseFloat(fourthStep[index].reflectivityCoefficient),
            acs: parseFloat(fourthStep[index].crossSection),
            drag_coefficient: parseFloat(fourthStep[index].dragCoefficient),
            target_perigee: parseInt(step4.directDisposalData.targetPerigee),
            disposal_system: step4?.directDisposalData?.disposalSystem?.value,
            type: 'direct_disposal'
          },
          type: "oscar"
        }
        pmdSchema.push(directDisposalSchema)
      }
    }
    if (targetedDeorbitState) {
      if (targetedDeorbitFile) {
        const name = filesArray.find(file => file.name === 'targetedDeorbit').file_name
        const targetedDeorbitFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(targetedDeorbitFileSchema)
      } else {
        const targetedDeorbitSchema = {
          keplerian: {
            raan: parseFloat(fourthStep[index].rightAscension),
            argument_perigee: parseFloat(fourthStep[index].argumentOfPerigee),
            sma: parseFloat(fourthStep[index].semiMajorAxis),
            eccentricity: parseFloat(fourthStep[index].eccentricity),
            inclination: parseFloat(fourthStep[index].inclination),
            mean_anomaly: parseFloat(fourthStep[index].meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(fourthStep[index].startEpoch),
            reflectivity_coefficient: parseFloat(fourthStep[index].reflectivityCoefficient),
            acs: parseFloat(fourthStep[index].crossSection),
            drag_coefficient: parseFloat(fourthStep[index].dragCoefficient),
            disposal_system: step4.targetedDeorbitData.disposalSystem.value,
            lifetime_limit: parseFloat(step4.targetedDeorbitData.lifetimeLimit),
            hohmann: parseInt(step4.targetedDeorbitData.hohmannTransfer),
            dad_reflectivity_coefficient: parseFloat(step4.targetedDeorbitData.reflectivityCoefficient),
            dad_acs: parseFloat(step4.targetedDeorbitData.crossSection),
            dad_drag_coefficient: parseFloat(step4.targetedDeorbitData.dragCoefficient),
            type: 'targeted_disposal'
          },

          type: "oscar"
        }
        pmdSchema.push(targetedDeorbitSchema)
      }
    }
    if (reorbitState) {
      if (reorbitFile) {
        const name = filesArray.find(file => file.name === 'reorbit').file_name
        const reorbitFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(reorbitFileSchema)
      } else {
        const reorbitSchema = {
          keplerian: {
            raan: parseFloat(fourthStep[index].rightAscension),
            argument_perigee: parseFloat(fourthStep[index].argumentOfPerigee),
            sma: parseFloat(fourthStep[index].semiMajorAxis),
            eccentricity: parseFloat(fourthStep[index].eccentricity),
            inclination: parseFloat(fourthStep[index].inclination),
            mean_anomaly: parseFloat(fourthStep[index].meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(fourthStep[index].startEpoch),
            reflectivity_coefficient: parseFloat(fourthStep[index].reflectivityCoefficient),
            acs: parseFloat(fourthStep[index].crossSection),
            drag_coefficient: parseFloat(fourthStep[index].dragCoefficient),
            disposal_system: step4.reorbitData.disposalSystem.value,
            hohmann: parseInt(step4.reorbitData.hohmannTransfer),
            altitude: parseFloat(step4.reorbitData.reorbitAltitude),
            type: "reorbit_disposal",

          },
          type: "oscar"



        }
        pmdSchema.push(reorbitSchema)
      }
    }
    if (noDisposal) {
      if (noDisposalFile) {
        const name = filesArray.find(file => file.name === 'noDisposal').file_name
        const noDisposalFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(noDisposalFileSchema)
      } else if (kingHele) {
        const noDisposalFileSchema = {
          keplerian: {
            raan: parseFloat(fourthStep[index].rightAscension),
            argument_perigee: parseFloat(fourthStep[index].argumentOfPerigee),
            sma: parseFloat(fourthStep[index].semiMajorAxis),
            eccentricity: parseFloat(fourthStep[index].eccentricity),
            inclination: parseFloat(fourthStep[index].inclination),
            mean_anomaly: parseFloat(fourthStep[index].meanAnomaly),
          },

          start_epoch: new Date(fourthStep[index].startEpoch),
          //reflectivity_coefficient: parseFloat(fourthStep[index].reflectivityCoefficient),
          acs: parseFloat(fourthStep[index].crossSection),
          drag_coefficient: parseFloat(fourthStep[index].dragCoefficient),
          type: "king_hele"
        }
        pmdSchema.push(noDisposalFileSchema)
      } else {
        const noDisposalFileSchema = {
          keplerian: {
            raan: parseFloat(fourthStep[index].rightAscension),
            argument_perigee: parseFloat(fourthStep[index].argumentOfPerigee),
            sma: parseFloat(fourthStep[index].semiMajorAxis),
            eccentricity: parseFloat(fourthStep[index].eccentricity),
            inclination: parseFloat(fourthStep[index].inclination),
            mean_anomaly: parseFloat(fourthStep[index].meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(fourthStep[index].startEpoch),
            reflectivity_coefficient: parseFloat(fourthStep[index].reflectivityCoefficient),
            acs: parseFloat(fourthStep[index].crossSection),
            drag_coefficient: parseFloat(fourthStep[index].dragCoefficient),
            type: "no_disposal",

          },
          type: "oscar"
        }
        pmdSchema.push(noDisposalFileSchema)
      }
    }
    return pmdSchema
  }

  const pmdSchema = () => {
    let pmdSchema = []
    if (directDisposal) {
      if (directDisposalFile) {
        const name = filesArray.find(file => file.name === 'directDisposal').file_name
        const directDisposalFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(directDisposalFileSchema)
      } else {
        const directDisposalSchema = {
          keplerian: {
            raan: parseFloat(step4.rightAscension),
            argument_perigee: parseFloat(step4.argumentOfPerigee),
            sma: parseFloat(step4.semiMajorAxis),
            eccentricity: parseFloat(step4.eccentricity),
            inclination: parseFloat(step4.inclination),
            mean_anomaly: parseFloat(step4.meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(step4.startEpoch),
            reflectivity_coefficient: parseFloat(step4.reflectivityCoefficient),
            acs: parseFloat(step4.crossSection),
            drag_coefficient: parseFloat(step4.dragCoefficient),
            target_perigee: parseInt(step4.directDisposalData.targetPerigee),
            disposal_system: step4?.directDisposalData?.disposalSystem?.value,
            type: 'direct_disposal'
          },
          type: "oscar"
        }
        pmdSchema.push(directDisposalSchema)
      }
    }
    if (targetedDeorbitState) {
      if (targetedDeorbitFile) {
        const name = filesArray.find(file => file.name === 'targetedDeorbit').file_name
        const targetedDeorbitFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(targetedDeorbitFileSchema)
      } else {
        const targetedDeorbitSchema = {
          keplerian: {
            raan: parseFloat(step4.rightAscension),
            argument_perigee: parseFloat(step4.argumentOfPerigee),
            sma: parseFloat(step4.semiMajorAxis),
            eccentricity: parseFloat(step4.eccentricity),
            inclination: parseFloat(step4.inclination),
            mean_anomaly: parseFloat(step4.meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(step4.startEpoch),
            reflectivity_coefficient: parseFloat(step4.reflectivityCoefficient),
            acs: parseFloat(step4.crossSection),
            drag_coefficient: parseFloat(step4.dragCoefficient),
            disposal_system: step4.targetedDeorbitData.disposalSystem.value,
            lifetime_limit: parseFloat(step4.targetedDeorbitData.lifetimeLimit),
            hohmann: parseInt(step4.targetedDeorbitData.hohmannTransfer),
            dad_reflectivity_coefficient: parseFloat(step4.targetedDeorbitData.reflectivityCoefficient),
            dad_acs: parseFloat(step4.targetedDeorbitData.crossSection),
            dad_drag_coefficient: parseFloat(step4.targetedDeorbitData.dragCoefficient),
            type: 'targeted_disposal'
          },

          type: "oscar"
        }
        pmdSchema.push(targetedDeorbitSchema)
      }
    }
    if (reorbitState) {
      if (reorbitFile) {
        const name = filesArray.find(file => file.name === 'reorbit').file_name
        const reorbitFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(reorbitFileSchema)
      } else {
        const reorbitSchema = {
          keplerian: {
            raan: parseFloat(step4.rightAscension),
            argument_perigee: parseFloat(step4.argumentOfPerigee),
            sma: parseFloat(step4.semiMajorAxis),
            eccentricity: parseFloat(step4.eccentricity),
            inclination: parseFloat(step4.inclination),
            mean_anomaly: parseFloat(step4.meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(step4.startEpoch),
            reflectivity_coefficient: parseFloat(step4.reflectivityCoefficient),
            acs: parseFloat(step4.crossSection),
            drag_coefficient: parseFloat(step4.dragCoefficient),
            disposal_system: step4.reorbitData.disposalSystem.value,
            hohmann: parseInt(step4.reorbitData.hohmannTransfer),
            altitude: parseFloat(step4.reorbitData.reorbitAltitude),
            type: "reorbit_disposal",

          },
          type: "oscar"



        }
        pmdSchema.push(reorbitSchema)
      }
    }
    if (noDisposal) {
      if (noDisposalFile) {
        const name = filesArray.find(file => file.name === 'noDisposal').file_name
        const noDisposalFileSchema = {
          type: 'file',
          file_name: name,
        }
        pmdSchema.push(noDisposalFileSchema)
      } else if (kingHele) {
        const noDisposalFileSchema = {
          keplerian: {
            raan: parseFloat(step4.rightAscension),
            argument_perigee: parseFloat(step4.argumentOfPerigee),
            sma: parseFloat(step4.semiMajorAxis),
            eccentricity: parseFloat(step4.eccentricity),
            inclination: parseFloat(step4.inclination),
            mean_anomaly: parseFloat(step4.meanAnomaly),
          },
          start_epoch: new Date(step4.startEpoch),
          // reflectivity_coefficient: parseFloat(step4.reflectivityCoefficient),
          acs: parseFloat(step4.crossSection),
          drag_coefficient: parseFloat(step4.dragCoefficient),
          type: "king_hele"



        }
        pmdSchema.push(noDisposalFileSchema)
      }
      else {
        const noDisposalFileSchema = {
          keplerian: {
            raan: parseFloat(step4.rightAscension),
            argument_perigee: parseFloat(step4.argumentOfPerigee),
            sma: parseFloat(step4.semiMajorAxis),
            eccentricity: parseFloat(step4.eccentricity),
            inclination: parseFloat(step4.inclination),
            mean_anomaly: parseFloat(step4.meanAnomaly),
          },
          disposal_option: {
            start_epoch: new Date(step4.startEpoch),
            reflectivity_coefficient: parseFloat(step4.reflectivityCoefficient),
            acs: parseFloat(step4.crossSection),
            drag_coefficient: parseFloat(step4.dragCoefficient),
            type: "no_disposal",

          },
          type: "oscar"



        }
        pmdSchema.push(noDisposalFileSchema)
      }
    }
    return pmdSchema
  }

  const getPropulsion = (propulsionTechnology) => {
    if (propulsionTechnology.propulsionTechnology.value === 'chemical') {
      return {
        isp: parseInt(propulsionTechnology.specificImpulse),
        type: 'chemical',
        technology: propulsionTechnology.propulsionTechnologySubtype.value,
      }
    } else if (propulsionTechnology.propulsionTechnology.value === 'electrical') {
      return {
        lifetime: parseInt(propulsionTechnology.thrustLifetime),
        isp: parseInt(propulsionTechnology.specificImpulse),
        type: 'electrical',
        technology: propulsionTechnology.propulsionTechnologySubtype.value,
        thrust: parseInt(propulsionTechnology.maximumThrust),
      }

    }
    else if (propulsionTechnology.propulsionTechnology.value === 'drag sail') {
      return {
        mass: parseInt(propulsionTechnology.mass),
        acs: parseInt(propulsionTechnology.effectiveSailArea),
        type: 'drag sail',
        technology: propulsionTechnology.propulsionTechnologySubtype.value,
      }
    } else {
      return {}
    }
  }
  const sendSingleMissionForm = async () => {
    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'))[0]

    const missionBody = {
      mission: {
        architecture: step1.architectureType,
        name: step1.missions,
        draft: true,
        version: step1.version,
      },
      space_vehicle: {
        acpl: parseFloat(step2?.MissionOperation.acpl) || 0,
        active: step2?.MissionOperation.camStatus === 'active',
        debris_trackability: step2?.MissionOperation.debrisTrackability,
        object_type: step2.SpacecraftDesign.objectType.label,
        type: 'spacecraft',
        cam: step2?.MissionOperation.cam === 'yes',
        pmd_reliability: parseFloat(step2?.MissionOperation.pmdSuccessRate) / 100 || 0,
        acs: parseFloat(step2?.SpacecraftDesign.cross) || 0,
        cam_efficacy: parseFloat(step2?.MissionOperation.cam_efficacy) / 100 || 0,
        mass: parseFloat(step2?.SpacecraftDesign.mass) || 0,
        propulsion: getPropulsion(step2?.PropulsionTechnology),
        phases: {
          injection: getOperationalOribitInjectionPhase(0),
          operational: getOperationalPhase(0),
          pmd: pmdSchema(),
          launch: getLaunchPhase(0),
        },
      }

    }
    if (missionBody.space_vehicle.debris_trackability === '') {
      delete missionBody.space_vehicle.debris_trackability
    }
    const filesZip = await getFilesAndZip()
    if (filesZip) {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', filesZip)
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((error) => {
                console.log(error)
                toast.error('An error occurred while calculating  the mission')
              })
          }
        })
        .catch((error) => {
          console.log(error)
          toast.error('An error occurred while creating the mission')
        })
    }
    else {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', '')
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {
            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user));
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((error) => {
                console.log(error)
                toast.error('An error occurred while calculating  the mission')
              })

          }
        })
        .catch((error) => {
          console.log(error)
          toast.error('An error occurred while creating the mission')
        })
    }
  }

  const getSpacecraftsSchemas = () => {
    const spacecrafts = []
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'))
    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))
    const spacecraftConfig = step1.satellitesPerOrbit

    step2.forEach((spacecraft, index) => {
      const spacecraftSchema = {
        acpl: parseFloat(spacecraft?.MissionOperation.acpl) || 0,
        active: spacecraft?.MissionOperation.camStatus === 'active',
        debris_trackability: spacecraft?.MissionOperation.debrisTrackability,
        years_deployed: parseInt(spacecraftConfig[index].launch_year),
        plane_lifetime: parseInt(spacecraftConfig[index].lifetime),
        number_of_satellites: parseInt(spacecraftConfig[index].satellites),
        object_type: spacecraft.SpacecraftDesign.objectType.label,
        type: 'spacecraft',
        cam: spacecraft?.MissionOperation.cam === 'yes',
        pmd_reliability: parseFloat(spacecraft?.MissionOperation.pmdSuccessRate) / 100 || 0,
        acs: parseFloat(spacecraft?.SpacecraftDesign.cross) || 0,
        cam_efficacy: parseFloat(spacecraft?.MissionOperation.cam_efficacy) / 100 || 0,
        mass: parseFloat(spacecraft?.SpacecraftDesign.mass) || 0,
        propulsion: getPropulsion(spacecraft?.PropulsionTechnology),
        phases: {
          launch: getLaunchPhase(index),
          injection: getOperationalOribitInjectionPhase(index),
          operational: getOperationalPhase(index),
          pmd: architectureType === 'constellation' ? pmdConstallationSchema(index) : pmdSchema(),
        }
      }

      if (spacecraftSchema.debris_trackability === '') {
        delete spacecraftSchema.debris_trackability
      }
      spacecrafts.push(spacecraftSchema)
    })
    return spacecrafts
  }


  const getLaunchPhase = (index) => {
    const step3 = JSON.parse(sessionStorage.getItem('thirdStep'))
    const launchPhase = []

    step3[index].launchPhase.forEach((phase) => {
      if (phase.type && phase.type === 'file') {
        const launchPhaseFileSchema = {
          type: 'file',
          file_name: phase.data,
        }
        launchPhase.push(launchPhaseFileSchema)
      } else {
        const launchPhaseSchema = {
          type: 'base',
          end_epoch: new Date(phase.end_epoch),
          start_epoch: new Date(phase.start_epoch),
          keplerian: {
            raan: parseFloat(phase.keplerian.raan),
            argument_perigee: parseFloat(phase.keplerian.argument_perigee),
            sma: parseFloat(phase.keplerian.sma),
            eccentricity: parseFloat(phase.keplerian.eccentricity),
            inclination: parseFloat(phase.keplerian.inclination),
            mean_anomaly: parseFloat(phase.keplerian.mean_anomaly),
          },
        }
        launchPhase.push(launchPhaseSchema)
      }


    })
    return launchPhase
  }

  const getOperationalOribitInjectionPhase = (index) => {
    const step3 = JSON.parse(sessionStorage.getItem('thirdStep'))
    const operationalOribitInjectionPhase = []

    step3[index].operationalOribitInjectionPhase.forEach((phase) => {
      if (phase.type && phase.type === 'file') {
        const operationalOribitInjectionPhaseFileSchema = {
          type: 'file',
          file_name: phase.data,
        }
        operationalOribitInjectionPhase.push(operationalOribitInjectionPhaseFileSchema)
      } else {
        const operationalOribitInjectionPhaseSchema = {
          type: 'base',
          end_epoch: new Date(phase.end_epoch),
          start_epoch: new Date(phase.start_epoch),
          keplerian: {
            raan: parseFloat(phase.keplerian.raan),
            argument_perigee: parseFloat(phase.keplerian.argument_perigee),
            sma: parseFloat(phase.keplerian.sma),
            eccentricity: parseFloat(phase.keplerian.eccentricity),
            inclination: parseFloat(phase.keplerian.inclination),
            mean_anomaly: parseFloat(phase.keplerian.mean_anomaly),
          },
        }
        operationalOribitInjectionPhase.push(operationalOribitInjectionPhaseSchema)
      }
    })
    return operationalOribitInjectionPhase
  }

  const getOperationalPhase = (index) => {
    const step3 = JSON.parse(sessionStorage.getItem('thirdStep'))
    const operationalPhase = []

    step3[index].operationalPhase.forEach((phase) => {
      if (phase.type && phase.type === 'file') {
        const operationalPhaseFileSchema = {
          type: 'file',
          file_name: phase.data,
        }
        operationalPhase.push(operationalPhaseFileSchema)
      } else {
        const operationalPhaseSchema = {
          type: 'base',
          end_epoch: new Date(phase.end_epoch),
          start_epoch: new Date(phase.start_epoch),
          keplerian: {
            raan: parseFloat(phase.keplerian.raan),
            argument_perigee: parseFloat(phase.keplerian.argument_perigee),
            sma: parseFloat(phase.keplerian.sma),
            eccentricity: parseFloat(phase.keplerian.eccentricity),
            inclination: parseFloat(phase.keplerian.inclination),
            mean_anomaly: parseFloat(phase.keplerian.mean_anomaly),
          },
        }
        operationalPhase.push(operationalPhaseSchema)
      }
    })
    return operationalPhase
  }

  const getAssociatedTo = (associatedTo) => {
    const associatedToSchema = []
    associatedTo.forEach((associated) => {
      associatedToSchema.push({
        weighted_value: parseFloat(associated?.weightedValue || associated?.weighted_value) || 0,
        spacecraft_id: parseInt(associated?.spacecraftId || associated?.spacecraft_id),
      })
    })
    return associatedToSchema
  }

  const sendCarrierMissionForm = async () => {
    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'))[0]
    const missionBody = {
      mission: {
        architecture: step1.architectureType,
        name: step1.missions,
        draft: true,
        version: step1.version,
      },
      space_vehicle: {
        acpl: parseFloat(step2?.MissionOperation.acpl) || 0,
        active: step2?.MissionOperation.camStatus === 'active',
        associated_to: getAssociatedTo(step1?.associatedTo),
        debris_trackability: step2?.MissionOperation.debrisTrackability,
        object_type: step2.SpacecraftDesign.objectType.label,
        type: 'carrier',
        cam: step2?.MissionOperation.cam === 'yes',
        pmd_reliability: parseFloat(step2?.MissionOperation.pmdSuccessRate) / 100 || 0,
        acs: parseFloat(step2?.SpacecraftDesign.cross) || 0,
        cam_efficacy: parseFloat(step2?.MissionOperation.cam_efficacy) / 100 || 0,
        mass: parseFloat(step2?.SpacecraftDesign.mass) || 0,
        propulsion: getPropulsion(step2?.PropulsionTechnology),
        phases: {
          injection: getOperationalOribitInjectionPhase(0),
          operational: getOperationalPhase(0),
          pmd: pmdSchema(),
          launch: getLaunchPhase(0),
        },
      }

    }

    if (missionBody.space_vehicle.debris_trackability === '') {
      delete missionBody.space_vehicle.debris_trackability
    }
    const filesZip = await getFilesAndZip()
    if (filesZip) {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', filesZip)
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((err) => {
                console.log(err)
                toast.error('An error occurred while calculating  the mission')
              })
          }
        })
        .catch((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }
    else {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', '')
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((err) => {
                console.log(err)
                toast.error('An error occurred while calculating  the mission')
              })
          }
        })
        .catch((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }
  }

  const sendConstellationMissionForm = async () => {
    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))

    const missionBody = {
      mission: {
        architecture: step1.architectureType,
        name: step1.missions,
        draft: true,
        version: step1.version,
        constellation_name: step1.constellationName,
      },

      space_vehicle: {
        spacecrafts: getSpacecraftsSchemas(),
        type: 'constellation',
      },
    }
    const filesZip = await getFilesAndZip()
    if (filesZip) {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', filesZip)
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_constellation_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((err) => {
                console.log(err)
                toast.error('An error occurred while calculating the mission')
              })
          }
        })
        .then((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }
    else {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', '')
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_constellation_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              }
              )
          }
        })

        .catch((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }
  }

  const sendMissionForm = () => {

    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))
    if (step1.architectureType === 'single') {
      sendSingleMissionForm()
    } else if (step1.architectureType === 'constellation') {
      sendConstellationMissionForm()
    } else if (step1.architectureType === 'carrier') {
      sendCarrierMissionForm()
    }

  }

  const changeInputType = (type, section) => {
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'))
    if (section === 'reorbit') {
      setReorbitFile(true)
      setStep4({
        ...step4,
        reorbitData: {
          disposalSystem: '',
          hohmannTransfer: '',
          reorbitAltitude: '',
        }
      })


    }
    if (section === 'targetedDeorbit') {
      setTargetedDeorbitFile(true)
      setStep4({
        ...step4,
        targetedDeorbitData: {
          targetPerigee: '',
          hohmannTransfer: '',
          lifetimeLimit: '',
          crossSection: '',
          dragCoefficient: '',
          reflectivityCoefficient: ''
        }
      })

    }
    if (section === 'directDisposal') {
      setDirectDisposalFile(true)
      setStep4({
        ...step4,
        directDisposalData: {
          disposalSystem: {
            value: step2[0]?.PropulsionTechnology?.propulsionTechnology?.value,
            label: step2[0]?.PropulsionTechnology?.propulsionTechnology?.label
          },
          targetPerigee: ''
        }
      })


    }
    if (section === 'noDisposal') {
      setNoDisposalFile(true)
    }

    if (type.value === 'file') {

      const fileObject = {
        name: section,
        type: 'file',
        file_name: '',
      }
      const files = [...filesArray]
      files.push(fileObject)
      setFilesArray(files)
    }
    else {
      if (type.value === 'king_hele') {
        setKingHele(true)
      } else if (section === 'noDisposal') {
        setKingHele(false)
      }
      const files = [...filesArray]
      const index = files.findIndex(file => file.name === section)
      files.splice(index, 1)
      setFilesArray(files)
      onFileDelete(section)
      db.files
        .where('phaseName')
        .equals(section)
        .and((file) => file.pmd === true)
        .delete()

      if (section === 'reorbit') {
        setReorbitFile(false)
      }
      if (section === 'targetedDeorbit') {
        setTargetedDeorbitFile(false)
      }
      if (section === 'directDisposal') {
        setDirectDisposalFile(false)
      }
      if (section === 'noDisposal') {
        setNoDisposalFile(false)
      }

    }

    if ((!directDisposal || directDisposalFile) && (!targetedDeorbitState || targetedDeorbitFile) && (!reorbitState || reorbitFile) && noDisposalFile) {
      resetManualAndKemeplerian()
    }
  }
  const onChangeFile = async (e, section) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(e[0]);
    reader.onload = async () => {

      await db.files
        .where('phaseName')
        .equals(section)
        .delete()

      filesArray.map((file) => {
        if (file.name === section) {
          file.file_name = e[0].name
        }
      })
      if (section === 'reorbit') {
        setReorbitFile(true)
        setStep4({
          ...step4,
          reorbitData: {

            type: 'file',
            file_name: e[0].name,
          }
        })


      }
      if (section === 'targetedDeorbit') {
        setTargetedDeorbitFile(true)
        setStep4({
          ...step4,
          targetedDeorbitData: {
            type: 'file',
            file_name: e[0].name,
          }
        })

      }
      if (section === 'directDisposal') {
        setDirectDisposalFile(true)
        setStep4({
          ...step4,
          directDisposalData: {
            type: 'file',
            file_name: e[0].name,
          }
        })
      }
      if (section === 'noDisposal') {
        setNoDisposal(true)
        setStep4({
          ...step4,
          noDisposalData: {
            type: 'file',
            file_name: e[0].name,
          }
        })
      }


      await db.files.add({
        name: e[0].name,
        data: e[0],
        phaseName: section,
        pmd: true,
      });


    };


  }

  const onFileDelete = (index, phase, index2) => {
    const files = [...filesArray]
    files.slice(files.findIndex(file => file.name === phase), 1)


  }


  const getDisposalDisabled = () => {
    if (!directDisposal && !targetedDeorbitState && !reorbitState) {
      return true
    }
    return false
  }

  return (
    <div style={{ width: '100%' }}>
      {architectureType !== 'constellation' &&
        (
          <>
            <Row>
              <Col xs={12} md={12} >
                <GeneralInputs
                  disabled={disabled}
                  step4={step4}
                  changeStarEpoch={changeStarEpoch}
                  changeCrossSection={changeCrossSection}
                  changeDragCoefficient={changeDragCoefficient}
                  changeReflectivityCoefficient={changeReflectivityCoefficient}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} >

                <KeplerianInputs
                  step4={step4}
                  disabled={disabled}
                  changeSemiMajorAxis={changeSemiMajorAxis}
                  changeEccentricity={changeEccentricity}
                  changeInclination={changeInclination}
                  changeRightAscension={changeRightAscension}
                  changeArgumentOfPerigee={changeArgumentOfPerigee}
                  changemMeanAnomaly={changemMeanAnomaly}
                />
              </Col>
            </Row>
          </>
        )
      }

      <Row>
        <Col xs={12} md={12} >
          <Form style={{ marginTop: '20px' }}>
            {
              architectureType !== 'launcher' && (
                <div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    <h4 style={{ color: '#003247', }}>No disposal</h4>
                    <Switch
                      disabled={disabled || getDisposalDisabled()}
                      checked={noDisposal}
                      onChange={changeNoDisposal}
                      onColor="#009bdb"
                      onHandleColor="#2e4149"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={15}
                      width={30}
                      className="react-switch"
                      id="material-switch"
                    />
                  </div>
                  {
                    noDisposal &&

                    <>
                      <div>
                        <Row className={style.rowForm}>
                          <Col xs={6} md={4} >

                            <Select
                              isDisabled={disabled}
                              className="react-select"
                              classNamePrefix="react-select"
                              value={{ value: noDisposalFile ? 'file' : (kingHele ? 'king_hele' : 'oscar'), label: noDisposalFile ? 'File(OEM)' : (kingHele ? 'King-Hele' : 'Oscar') }}
                              onChange={(value) => changeInputType(value, 'noDisposal')}
                              options={[
                                { value: 'file', label: 'File(OEM)' },
                                { value: 'oscar', label: 'Oscar' },
                                { value: 'king_hele', label: 'King-Hele' },
                              ]}></Select>
                          </Col>
                        </Row>
                      </div>
                      {
                        noDisposalFile &&
                        <div>
                          <Row className={style.rowForm}>
                            <Col xs={12} >
                              <FileUpload
                                step={'fourth'}
                                disabled={disabled}
                                showPreview={true}
                                phase={'noDisposal'}
                                onFileDelete={onFileDelete}
                                onFileUpload={(files) => {
                                  onChangeFile(files, 'noDisposal')
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      }
                    </>
                  }
                  {propulsionType === 'chemical' &&
                    <>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <h4 style={{ color: '#003247', }}>Direct disposal</h4>
                        <Switch
                          disabled={disabled}
                          checked={directDisposal}
                          onChange={changeDirectDisposal}
                          onColor="#009bdb"
                          onHandleColor="#2e4149"
                          handleDiameter={20}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={15}
                          width={30}
                          className="react-switch"
                          id="material-switch"
                        />
                      </div>
                      <>
                        {
                          directDisposal &&
                          <>
                            <div>
                              <Row className={style.rowForm}>
                                <Col xs={6} md={4} >
                                  <Select
                                    className='select'
                                    isDisabled={disabled}
                                    classNamePrefix="react-select"
                                    value={{ value: directDisposalFile ? 'file' : 'oscar', label: directDisposalFile ? 'File(OEM)' : 'Oscar' }}
                                    onChange={(value) => changeInputType(value, 'directDisposal')}
                                    options={[
                                      { value: 'file', label: 'File(OEM)' },
                                      { value: 'oscar', label: 'Oscar' },
                                    ]}></Select>
                                </Col>
                              </Row>

                            </div>
                            {
                              directDisposalFile ?
                                <div>
                                  <Row className={style.rowForm}>
                                    <Col xs={12} >
                                      <FileUpload
                                        step={'fourth'}
                                        disabled={disabled}
                                        showPreview={true}
                                        phase={'directDisposal'}
                                        onFileDelete={onFileDelete}
                                        onFileUpload={(files) => {
                                          onChangeFile(files, 'directDisposal')
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                                :
                                <DirectDisposal
                                  disabled={disabled}
                                  step4={step4}
                                  changeTargetPerigee={changeTargetPerigee}
                                  changeInputType={changeInputType}
                                />
                            }

                          </>
                        }
                      </>
                    </>
                  }
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Target-time deorbit: 
                          Automatically find the deorbit trajectory to render in a target time
                        </Tooltip>
                      }>
                      <h4 style={{ color: '#003247', }}>Target-time deorbit</h4>
                    </OverlayTrigger>
                    <Switch
                      disabled={disabled}
                      checked={targetedDeorbitState}
                      onChange={changeTargetedDeorbit}
                      onColor="#009bdb"
                      onHandleColor="#2e4149"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={15}
                      width={30}
                      className="react-switch"
                      id="material-switch"
                    />
                  </div>
                  {
                    targetedDeorbitState &&
                    <>
                      <div>
                        <Row className={style.rowForm}>
                          <Col xs={6} md={4} >
                            <Select
                              isDisabled={disabled}
                              className="react-select"
                              classNamePrefix="react-select"
                              value={{ value: targetedDeorbitFile ? 'file' : 'oscar', label: targetedDeorbitFile ? 'File(OEM)' : 'Oscar' }}
                              onChange={(value) => changeInputType(value, 'targetedDeorbit')}
                              options={[
                                { value: 'file', label: 'File(OEM)' },
                                { value: 'oscar', label: 'Oscar' },
                              ]}></Select>
                          </Col>
                        </Row>
                      </div>
                      {
                        targetedDeorbitFile ? (
                          <Row className={style.rowForm}>
                            <Col xs={12} >
                              <FileUpload
                                disabled={disabled}
                                showPreview={true}
                                step={'fourth'}
                                phase={'targetedDeorbit'}
                                onFileDelete={onFileDelete}
                                onFileUpload={(files) => {
                                  onChangeFile(files, 'targetedDeorbit')
                                }}
                              />
                            </Col>
                          </Row>
                        ) : (
                          <TargetedDeorbit
                            disabled={disabled}
                            onChangeDisposalSystemTargetedDeorbit={onChangeDisposalSystemTargetedDeorbit}
                            changeLifetimeLimit={changeLifetimeLimit}
                            changeHohmannTransfer={changeHohmannTransferTargetedDeorbit}
                            changeTargetedDeorbitCrossSection={changeTargetedDeorbitCrossSection}
                            changeTargetedDeorbitDragCoefficient={changeTargetedDeorbitDragCoefficient}
                            changeTargetedDeorbitReflectivityCoefficient={changeTargetedDeorbitReflectivityCoefficient}
                            step4={step4}
                            propulsionType={propulsionType}
                          />
                        )
                      }
                    </>
                  }

                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                        Target-orbit deorbit:
                        Target a final tarjet orbit
                          </Tooltip>
                      }>
                      <h4 style={{ color: '#003247', }}>Target-orbit deorbit</h4>
                      </OverlayTrigger>
                      <Switch
                        disabled={disabled}
                        checked={reorbitState}
                        onChange={changeReorbit}
                        onColor="#009bdb"
                        onHandleColor="#2e4149"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={15}
                        width={30}
                        className="react-switch"
                        id="material-switch"
                      />
                    </div>
                    {
                      reorbitState &&
                      <>
                        <div>
                          <Row className={style.rowForm}>
                            <Col xs={6} md={4} >

                              <Select
                                isDisabled={disabled}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={{ value: reorbitFile ? 'file' : 'oscar', label: reorbitFile ? 'File(OEM)' : 'Oscar' }}
                                onChange={(value) => changeInputType(value, 'reorbit')}
                                options={[
                                  { value: 'file', label: 'File(OEM)' },
                                  { value: 'oscar', label: 'Oscar' },
                                ]}></Select>
                            </Col>
                          </Row>
                        </div>

                        {
                          reorbitFile ?
                            (
                              <Row className={style.rowForm}>
                                <Col xs={12} >
                                  <FileUpload
                                    disabled={disabled}
                                    showPreview={true}
                                    phase={'reorbit'}
                                    step={'fourth'}
                                    onFileDelete={onFileDelete}
                                    onFileUpload={(files) => {
                                      onChangeFile(files, 'reorbit')
                                    }}
                                  />
                                </Col>
                              </Row>

                            ) : (
                              <Reorbit
                                disabled={disabled}
                                step4={step4}
                                onChangeDisposalSystemReorbit={onChangeDisposalSystemReorbit}
                                changeHohmanTransferReorbit={changeHohmanTransferReorbit}
                                changeReorbitAltitude={changeReorbitAltitude}
                              />
                            )

                        }
                      </>
                    }
                  </>


                </div>
              )
            }

          </Form>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div style={{ paddingTop: '20px', paddingBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button style={{ background: '#003247', borderColor: '#003247' }}
              onClick={() => {
                props.handleBack()
                saveStep4()
              }}>
              Previous
            </Button>
            {
              !disabled &&
              <Button disabled={validate()} style={{ background: '#003247', borderColor: '#003247' }} onClick={() => sendMissionForm()} >
                Compute Debris Index
              </Button>
            }

          </div>
        </Col>
      </Row>
    </div>
  )
}

export default PMDphases